<template>
  <one-page-layout>
    <div class="loading"></div>
    <div class="loading__text">連線中...請稍候</div>
  </one-page-layout>
</template>

<script>
import OnePageLayout from '@/components/OnePageLayout.vue';

export default {
  async created() {
    this.$store.dispatch('getUserInfo').then(async (user) => {
      // 先確認local端是否有使用者（上一頁無轉導）
      if (user) {
        this.$store.dispatch('logoutRedirectUnityPage');
        this.$router.push('/');
      } else {
        // 沒有使用者才進行loginRedirectCallback（登入頁轉導）
        await this.$store.dispatch('loginRedirectCallback');
        this.$router.replace('/');
      }
    });
  },
  components: {
    OnePageLayout,
  },
};
</script>
<style scoped>
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  -webkit-mask-image: radial-gradient(
    circle at center,
    transparent 50%,
    #fff 52%
  );
  mask-image: radial-gradient(circle at center, transparent 50%, #fff 52%);
  background: conic-gradient(
    from 90deg at 50%,
    at 50%,
    hsla(0, 0%, 100%, 0.0001) 0deg,
    #FFB13B 1turn
  );
  background: conic-gradient(
    from 90deg at 50% 50%,
    hsla(0, 0%, 100%, 0.0001) 0deg,
    #FFB13B 1turn
  );
  position: relative;
  -webkit-animation: cm-spin 1s linear infinite;
  animation: cm-spin 1s linear infinite;
}
.loading__text {
  padding-top: 10px;
  width: 100%;
  text-align: center;
  color: #595959;
  line-height: 24px;
  font-size: 16px;
}
</style>
